import React from 'react';
import PropTypes from 'prop-types';
import classes from '../addScripts.module.scss';
import Select from '../../../../_common/Form/Selects/Select/Select';
import InputField from '../../../../_common/Form/TextFields/InputField';
import DOBPicker from '../../../../_common/Form/DatePickers/DOBPicker/DOBPicker';

const deliveryOptions = [
  'UPS',
  'Fedex',
  'GSO',
  'Deliver-it',
  'US Postal',
  'Delivery Driver',
  'Pick Up',
];

const paymentOptions = [
  'Collect on Delivery',
  'Mail in Check',
  'Credit Card',
  'No Copay',
];

const Shipping = ({
  shippingInfo: {
    shipOn, deliveryMethod, paymentOption, ETA, trackNum
  },
  setShipping, errors
}) => (
  <div className={classes.authorization_wrapper}>
    <h4>Shipping</h4>

    <div className={classes.fields_block}>
      <div className={classes.fields_left_block}>
        <DOBPicker
          label="Ship On"
          date={shipOn}
          dateFormat="YYYY-MM-DD"
          onChange={(date) => setShipping('shipOn', date)}
          autoValidation={false}
          error={errors.shipOn}
        />

        <Select
          label="Delivery Method"
          onChange={(option) => setShipping('deliveryMethod', option)}
          currentOption={deliveryMethod}
          options={deliveryOptions}
        />

        <InputField
          label="Tracking Number"
          value={trackNum}
          onChange={(value) => setShipping('trackNum', value)}
        />
      </div>

      <div className={classes.fields_right_block}>
        <DOBPicker
          label="ETA"
          date={ETA}
          dateFormat="YYYY-MM-DD"
          onChange={(date) => setShipping('ETA', date)}
          autoValidation={false}
          error={errors.ETA}
        />

        <Select
          label="Payment Option"
          onChange={(option) => setShipping('paymentOption', option)}
          currentOption={paymentOption}
          options={paymentOptions}
        />
      </div>
    </div>
  </div>
);

Shipping.propTypes = {
  shippingInfo: PropTypes.object.isRequired,
  setShipping: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
};

export default Shipping;
